import { ErrorMessage } from "common/components/StyledElements";
import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  render() {
    const { children } = this.props;
    const { hasError } = this.state;

    if (hasError) {
      return <ErrorMessage>Something Wrong</ErrorMessage>;
    }

    return children;
  }
}

export default ErrorBoundary;
